import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router'



class ChangePasswordConfirmation extends Component {
    
   constructor(props) { 
        super(props);
        this.state={}
   }

   render() {

        return (
            <Container >
              <div className="page-register-confirmation">

                    <Row>
                        <Col>
                            <Link to="/"><div className="bloc-right center close">X</div></Link>
                        </Col>
                    </Row>

                    <div className="page-register-confirmation-container">
                        <Row>
                            <Col>
                                <div className="confirmation-title">Votre mot de passe a bien été modifié. Vous pouvez maintenant vous connecter.</div>
                                
                            </Col>
                        </Row>

                    </div>

                    <div  className="page-register-confirmation-container-action">
                      <Row>
                          <Col>
                              <Link to="/login/"><Button className="btn-green">Se connecter</Button></Link>
                          </Col>
                      </Row>
                    </div>

                </div>
            </Container>
        )
    }
}

export default ChangePasswordConfirmation


// WEBPACK FOOTER //
// ./src/user/components/ChangePasswordConfirmation.js